import { all, takeLatest } from 'redux-saga/effects';
import { constants } from '../config';

// eslint-disable-next-line require-yield
export function* setShowNotAllowedToBuy() {
  // set action state
}

function* actionWatcher() {
  yield takeLatest(constants.SHOW_NOT_ALLOWED_TO_BUY, setShowNotAllowedToBuy);
}

export default function* rootSaga() {
  yield all([actionWatcher()]);
}
